import * as DrupalModel from '../../../api/drupal/drupalTypes'
import { getCookie } from '../../../utils/cookies'
import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { fetchBranchLocations } from './BranchLocalizationApi'
import { PREF_BRANCH_COOKIE } from './BranchLocalizationUtils'

export type LocalizationState = {
  selectedLocationId: string
  branchLocations: AsyncState<DrupalModel.Location[]>
}

export const initialLocalizationState: LocalizationState = {
  selectedLocationId: getCookie(PREF_BRANCH_COOKIE) ? getCookie(PREF_BRANCH_COOKIE) : '',
  branchLocations: loadingAsyncState(fetchBranchLocations)
}
